import { SVGProps } from "react"

const PhoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.71305 3.01001C5.82949 3.01009 5.94378 3.04127 6.04411 3.10035C6.14445 3.15942 6.22717 3.24423 6.28372 3.34601L7.08239 4.78468C7.13397 4.87751 7.16214 4.98152 7.16446 5.08769C7.16678 5.19387 7.14319 5.29901 7.09572 5.39401L6.32639 6.93334C6.32639 6.93334 6.54905 8.08001 7.48239 9.01334C8.41572 9.94668 9.55839 10.1653 9.55839 10.1653L11.0977 9.39601C11.1927 9.34854 11.2979 9.32495 11.404 9.32727C11.5102 9.32959 11.6142 9.35776 11.7071 9.40934L13.1497 10.212C13.3571 10.3267 13.4857 10.5453 13.4857 10.7827V12.4393C13.4857 13.2827 12.7024 13.8927 11.9031 13.622C10.2611 13.0687 7.71239 12.0133 6.09705 10.398C4.48172 8.78334 3.42705 6.23468 2.87305 4.59334C2.60372 3.79401 3.21305 3.01068 4.05639 3.01068H5.71305V3.01001Z"
      stroke="#898A93"
      strokeLinejoin="round"
    />
  </svg>
)

export default PhoneIcon
